// extracted by css-extract-rspack-plugin
export default {"anchor":"IconButtonSelector-module__anchor__CqN0z"};